const SldsButton = () => {
    return (
        <div>
        <button class="slds-button">Button</button>
        <button class="slds-button slds-button_neutral">Neutral Button</button>
        <button class="slds-button slds-button_brand">Brand Button</button>
        <button class="slds-button slds-button_outline-brand">Outline Brand Button</button>
        <button class="slds-button slds-button_destructive">Destructive Button</button>
        <button class="slds-button slds-button_text-destructive">Text Destructive Button</button>
        <button class="slds-button slds-button_success">Success Button</button>
        </div>
    )
  }
export default SldsButton;